(ns frontend.view.settings2.funds.events
  (:require [common.localization :as loc]
            [frontend.actions.entity :as entity-actions]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
            [frontend.view.modals.error-message.view :as error-message]))

(defn delete-fund! [fund]
  (let [fund-id (:db/id fund)]
    (entity-actions/*->disable! fund-id
                                (fn [_])
                                (fn [e]
                                  (modals/open-modal!
                                   error-message/modal-key
                                   {:body-content   (loc/tr :fund-cannot-be-deleted)
                                    :title          (loc/tr :attention)
                                    :ok-button-text (loc/tr :back)})))))

(defn start-delete-fund! [fund]
  (modals/open-modal!
   delete-confirmation-modal/modal-key
   {:body       (loc/tr :fund-delete [(:fund/name fund)])
    :on-delete! (fn [_]
                  (delete-fund! fund))}))
